import { memo } from "react";
import { Divider } from "antd";
import { ExportOutlined } from "@ant-design/icons";

import { CollectResponse, EItemType, IItem, IItemOption } from "../../interfaces";

import { formatStringList, formatValue } from "../../../../utils/simulador";
import './style.css';

import robotImg from '../../../../assets/imagens/robot-chat-icon.png';
import userImg from '../../../../assets/imagens/user-chat-icon.png';

interface IProps {
  item: IItem | null;
  text?: string;
}

function Message({
  text,
  item,
}: IProps) {
  if (!text && !item?.message_text) {
    return null;
  }

  const isResponse = !!item?.response;

  return (
    <div className={`messageContainer ${isResponse ? 'responseMessageContainer' : ''}`} >
      <img src={!isResponse ? robotImg : userImg} className="avatarImg" />

      <div className={`chatMessage ${isResponse ? 'chatResponseMessage' : ''}`}>
        {
          !isResponse ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <span>
                {text || item?.message_text}
              </span>
            </div>
          ) : (
            <>
              {
                (typeof item.response === "string" || typeof item.response === "number") ? (
                  <span>
                    {item.format ? formatValue({ format: item.format, value: item.response }) : item.response}
                  </span>
                ) : (
                  <>
                    {
                      item.type === EItemType.COLLECT && (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                          }}
                        >
                          {
                            item.type === EItemType.COLLECT && item.response && 'map' in item.response && typeof item.response.map !== "string" && (item.response as CollectResponse[])?.map((response: CollectResponse) => (
                              <span key={response.name} >
                                <span style={{ fontWeight: 700 }}>{response.label}:</span> {formatValue({ format: response?.format, value: response.value })}
                              </span>
                            ))
                          }
                        </div>
                      )
                    }

                    {
                      item.type === EItemType.OPTIONS && (
                        <span>
                          {formatStringList((item.response as IItemOption[]).map((e) => e.text))}
                        </span>
                      )
                    }
                  </>
                )
              }
            </>
          )
        }

        {
          item?.link_text && item.link && (
            <div>
              <Divider
                style={{
                  marginTop: 8,
                  marginBottom: 10,
                }}
              />

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                }}
              >
                <ExportOutlined
                  style={{
                    color: "#1D4ED8"
                  }}
                />

                <a
                  href={item.link}
                  target="_blank"
                  style={{
                    color: "#1D4ED8"
                  }}
                >
                  {item.link_text}
                </a>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default memo(Message);
